(function () {
  const PANEL_SELECTOR = 'cart-discount-code-panel';
  const EXTRAS_SELECTOR = '.cart-sidebar-extras';

  function getOpenExtraIds() {
    const ids = [];
    document.querySelectorAll(`${EXTRAS_SELECTOR} details.cart-extra-card[data-extra-id]`).forEach((el) => {
      if (el.open) ids.push(el.getAttribute('data-extra-id'));
    });
    return ids;
  }

  function restoreOpenExtras(openIds) {
    if (!openIds.length) return;
    openIds.forEach((id) => {
      const el = document.querySelector(`${EXTRAS_SELECTOR} details.cart-extra-card[data-extra-id="${id}"]`);
      if (el) el.open = true;
    });
  }

  async function refreshCartSidebar() {
    const openExtraIds = getOpenExtraIds();

    const response = await fetch('?section_id=helper-cart');
    const text = await response.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');

    const cartFormInnerHTML = doc.getElementById('AjaxCartForm')?.innerHTML;
    const cartSubtotalInnerHTML = doc.getElementById('AjaxCartSubtotal')?.innerHTML;

    if (cartFormInnerHTML) {
      const cartForm = document.getElementById('AjaxCartForm');
      if (cartForm) {
        cartForm.innerHTML = cartFormInnerHTML;
        if (typeof cartForm.ajaxifyCartItems === 'function') {
          cartForm.ajaxifyCartItems();
        }
      }
    }

    if (cartSubtotalInnerHTML) {
      document.querySelectorAll('#AjaxCartSubtotal').forEach((el) => {
        el.innerHTML = cartSubtotalInnerHTML;
      });
    }

    document.querySelectorAll('[data-header-cart-count]').forEach((elm) => {
      const countEl = document.querySelector('#AjaxCartForm [data-cart-count]');
      if (countEl) elm.textContent = countEl.textContent;
    });
    document.querySelectorAll('[data-header-cart-total]').forEach((elm) => {
      const totalEl = document.querySelector('#AjaxCartForm [data-cart-total]');
      if (totalEl) elm.textContent = totalEl.textContent;
    });

    restoreOpenExtras(openExtraIds);
    initCartDiscountPanels(document);
  }

  function showPanelMessage(panel, message, type) {
    const el = panel.querySelector('.cart-discount-code-message');
    if (!el) return;
    el.textContent = message || '';
    el.classList.remove('cart-discount-code-message--error', 'cart-discount-code-message--success');
    if (type === 'error') el.classList.add('cart-discount-code-message--error');
    if (type === 'success') el.classList.add('cart-discount-code-message--success');
  }

  function setPanelBusy(panel, busy) {
    panel.classList.toggle('cart-discount-code-panel--busy', busy);
    panel.querySelectorAll('.cart-discount-code-apply, .cart-discount-code-remove').forEach((btn) => {
      btn.disabled = busy;
    });
  }

  function collectCodesFromCart(cart) {
    const codes = [];
    if (Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach((entry) => {
        if (entry.code) codes.push(entry.code.toUpperCase());
      });
    }
    return [...new Set(codes)];
  }

  function isCheckoutOnlyDiscount(cart, codeUpper) {
    const entry = (cart.discount_codes || []).find((d) => d.code && d.code.toUpperCase() === codeUpper);
    if (!entry || entry.applicable === false) return false;

    let visibleDiscount = false;
    if (Array.isArray(cart.items)) {
      for (const item of cart.items) {
        const allocations = item.line_level_discount_allocations || item.discounts || [];
        for (const allocation of allocations) {
          const app = allocation.discount_application || allocation;
          if (app && app.type === 'discount_code' && app.title && app.title.toUpperCase() === codeUpper) {
            visibleDiscount = true;
            break;
          }
        }
        if (visibleDiscount) break;
      }
    }

    const cartApps = cart.cart_level_discount_applications || [];
    for (const app of cartApps) {
      if (app.type === 'discount_code' && app.title && app.title.toUpperCase() === codeUpper && app.total_allocated_amount > 0) {
        visibleDiscount = true;
        break;
      }
    }

    return !visibleDiscount;
  }

  async function updateCartDiscounts(discountString) {
    const cartUpdateUrl = (window.KROWN && window.KROWN.settings && window.KROWN.settings.routes && window.KROWN.settings.routes.cart_url)
      ? `${window.KROWN.settings.routes.cart_url.replace(/\/?$/, '')}/update.js`
      : '/cart/update.js';
    const response = await fetch(cartUpdateUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: discountString }),
    });
    return response.json();
  }

  async function applyDiscount(panel, codeRaw) {
    const code = (codeRaw || '').trim().toUpperCase();
    if (!code) return;

    const singleOnly = panel.dataset.singleDiscountOnly === 'true';
    const messages = panel.dataset;

    setPanelBusy(panel, true);
    showPanelMessage(panel, '', null);

    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const existing = collectCodesFromCart(cart);

      if (singleOnly && existing.length > 0 && !existing.includes(code)) {
        showPanelMessage(panel, messages.messageSingleOnly, 'error');
        return;
      }

      const merged = [...new Set([...existing, code])];
      const updated = await updateCartDiscounts(merged.join(','));

      const applied = (updated.discount_codes || []).find((d) => d.code && d.code.toUpperCase() === code);
      if (!applied || applied.applicable === false) {
        showPanelMessage(panel, messages.messageInvalid, 'error');
        return;
      }

      if (isCheckoutOnlyDiscount(updated, code)) {
        showPanelMessage(panel, messages.messageCheckoutOnly, 'success');
      } else {
        showPanelMessage(panel, messages.messageSuccess, 'success');
      }

      await refreshCartSidebar();
    } catch (e) {
      console.error(e);
      showPanelMessage(panel, messages.messageCartError, 'error');
    } finally {
      setPanelBusy(panel, false);
    }
  }

  async function removeDiscount(panel, codeRaw) {
    const code = (codeRaw || '').trim().toUpperCase();
    if (!code) return;

    setPanelBusy(panel, true);
    showPanelMessage(panel, '', null);

    try {
      const cart = await fetch('/cart.js').then((r) => r.json());
      const remaining = collectCodesFromCart(cart).filter((c) => c !== code);
      await updateCartDiscounts(remaining.join(','));
      await refreshCartSidebar();
    } catch (e) {
      console.error(e);
      showPanelMessage(panel, panel.dataset.messageCartError, 'error');
    } finally {
      setPanelBusy(panel, false);
    }
  }

  function initCartDiscountPanels(root = document) {
    root.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      if (panel.dataset.initialized === 'true') return;
      panel.dataset.initialized = 'true';

      const applyBtn = panel.querySelector('.cart-discount-code-apply');
      const input = panel.querySelector('.cart-discount-code-input');

      applyBtn?.addEventListener('click', () => applyDiscount(panel, input?.value));
      input?.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') {
          event.preventDefault();
          applyDiscount(panel, input.value);
        }
      });

      panel.querySelectorAll('.cart-discount-code-remove').forEach((btn) => {
        btn.addEventListener('click', () => removeDiscount(panel, btn.dataset.code));
      });
    });
  }

  function resetCartDiscountPanels(root = document) {
    root.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      delete panel.dataset.initialized;
    });
    initCartDiscountPanels(root);
  }

  document.addEventListener('DOMContentLoaded', () => {
    if (!document.querySelector(PANEL_SELECTOR)) return;
    initCartDiscountPanels(document);
  });

  document.addEventListener('cart-updated', () => {
    resetCartDiscountPanels(document);
  });

  window.decoriumRefreshCartSidebar = refreshCartSidebar;
})();
